import { FC } from 'react';
import { Helmet } from 'react-helmet';

const GA_MEASUREMENT_ID: string | undefined = import.meta.env
  .VITE_GA_MEASUREMENT_ID;

const GOOGLE_ADS_ID: string | undefined = import.meta.env.VITE_GOOGLE_ADS_ID;

const GoogleAndMetaAnalytics: FC = () => {
  return (
    <Helmet>
      {/* Google Analytics Start */}
      <script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
      />
      {/* Google Analytics End */}

      {/* Google Ads Start */}
      <script>
        {`
          window.dataLayer = window.dataLayer || [];

          function gtag() {
            dataLayer.push(arguments);
          }

          gtag('js', new Date());
          gtag('config', '${GA_MEASUREMENT_ID}');
          ${GOOGLE_ADS_ID ? `gtag('config', '${GOOGLE_ADS_ID}');` : ''}

        `}
      </script>
      {/* Google Ads End */}

      {/* Facebook Pixel Start */}

      <script>
        {`
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1298178180352856');
        fbq('track', 'PageView');
        `}
      </script>
      {/* Facebook Pixel End */}

      {/* Facebook Pixel Start */}

      <noscript>
        {`
        <img height="1" width="1" style="display:none"
        src="https://www.facebook.com/tr?id=1298178180352856&ev=PageView&noscript=1"
        />
        `}
      </noscript>
      {/* Facebook Pixel End */}

      {/* Microsoft Clarity Pixel Start */}
      <script>
        {`
        (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "owhkwc9eul");
      `}
      </script>
      {/* Microsoft Clarity Pixel End */}
    </Helmet>
  );
};

export default GoogleAndMetaAnalytics;
